import { graphql, useStaticQuery } from 'gatsby'
import { FixedObject } from 'gatsby-image'
import { VideoTabbar } from './type'

interface FAQItem {
  faq_h: string
  faq_q: string
  faq_a: string
}

interface EventPricing {
  h: string
  q: string
  before: string
  after: string
  prices: {
    item: {
      label: string
      price: string
      price_offer?: string
    }
  }[]
  offer_active: boolean
  // offer_img?: FixedObject
}

interface CoronaBubble {
  h: string
  content: string
}

interface Testimonials {
  h: string
  nav: string
  desc: string
  quotes: {
    quote: string
    author: string
    info_1: string
    info_2: string
    avatar: { childImageSharp: { fixed: FixedObject } }
  }[]
}

interface References {
  h: string
  slider: { 
    logo: { childImageSharp: { fixed: FixedObject } }
    alt: string
    url: string
  }[]
}

export interface Event {
  title: string
  intro: string
  corona_bubble: CoronaBubble
  videos: VideoTabbar
  impression: string
  testimonials: Testimonials
  faq: {
    faq_item: FAQItem
  }[]
  pricing: EventPricing
  outro: string
  references: References
}

interface TData {
  eventYaml: { [lang: string]: Event }
}

export const eventQuery = graphql`
  query EventQuery {
    eventYaml {
      de {
        title
        intro
        corona_bubble {
          h
          content
        }
        videos {
          tab_1 {
            title
            videoId
          }
          tab_2 {
            title
            videoId
          }
        }
        impression
        testimonials {
          h
          nav
          desc
          quotes {
            quote
            author
            info_1
            info_2
            avatar {
              childImageSharp {
                fixed(width: 72, height: 72) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
        }
        faq {
          faq_item {
            faq_h
            faq_q
            faq_a
          }
        }
        pricing {
          h
          q
          before
          after
          prices {
            item {
              label
              price
              price_offer
            }
          }
          offer_active
        }
        outro
        references {
          h
          slider {
            logo {
              childImageSharp {
                fixed(height: 48) {
                  ...GatsbyImageSharpFixed_noBase64
                }
              }
            }
            alt
            url
          }
        }
      }
    }
  }
`

export const useEvent = () => useStaticQuery<TData>(eventQuery).eventYaml.de
